<template>
  <div class="container">
    <div class="row">
      <div v-if="description" class="col-md-7" v-html="description"></div>
      <div :class="description ? ['col-md-4', 'offset-md-1'] : 'col'">
        <div
          class="row ps-0 pt-5 pt-md-0"
          v-for="question in questions"
          :key="question.id"
        >
          <div
            v-if="question.label"
            class="col-md-6 d-flex align-items-md-end"
            v-html="question.label"
          ></div>
          <div class="col-md-1"></div>
          <div class="col-md-5 pe-0 flex-grow-1">
            <div class="row d-flex justify-content-around">
              <!-- TODO: align-items-center based on whether we have a label and/or an icon? -->
              <div
                class="col-1 pl-md-1 d-flex align-items-top justify-content-center mb-0 mx-0 px-5 py-3 styled-likert"
                :class="{ selected: question.response === index }"
                v-for="(choice, index) in question.choices"
                :key="index"
              >
                <input
                  :id="`radio-${question.id}-${index}`"
                  type="radio"
                  :name="'radio-group-' + question.id"
                  v-model="question.response"
                  :value="index"
                  v-on:change="handleInputCompleted"
                />

                <label
                  class="text-center"
                  :for="`radio-${question.id}-${index}`"
                >
                  <img
                    :src="choice.icon"
                    :title="choice.label"
                    style="width: 32px"
                    class="mb-3"
                    v-if="choice.icon"
                  />
                  {{ choice.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StyledLikertScale'
}
</script>

<style>
.styled-likert input[type="radio"] {
  display: none;
}

div.styled-likert {
  border-radius: 10px;
  border-style: solid;
  border-color: #00000000;
}

div.selected.styled-likert {
  border-color: #aad0e9;
  background-color: #ecf0f1;
}
</style>
